import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { ClassNames } from '@emotion/react';

const FormLayout = ({
  subtitle,
  title,
  description,
  children,
  className = '',
  icon,
}: any) => {

  return (
    <Grid container className={`form-layout-container ${className}`}>
      <Box component="p" m={0} className='subtitle'>
        {subtitle}
      </Box>
      {title && <Grid container alignItems={"center"}><Box component="h1" m={0} className='title'>
        {title} 
      </Box>{icon ? icon : null}</Grid>}
      <Box component="p" m={0} className='description text-md'>
        {description}
      </Box>
      {children}
    </Grid>
  );
};

export default FormLayout;